import { render, staticRenderFns } from "./flatCard.vue?vue&type=template&id=0f46c5fa&scoped=true"
import script from "./flatCard.vue?vue&type=script&lang=js"
export * from "./flatCard.vue?vue&type=script&lang=js"
import style0 from "./flatCard.vue?vue&type=style&index=0&id=0f46c5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f46c5fa",
  null
  
)

export default component.exports